import React from 'react'
import moment from 'moment'

import DialogueTouchableOpacity from 'APP/Components/DialogueTouchableOpacity'
import {
  DAY_ITEM_SIZE,
  DAY_ITEM_BORDER_WIDTH,
  DayProgress,
  FullSizeTouchTarget,
  SelectedDayIndicator,
} from './style'

interface DayItemProps {
  day: string
  selectedDay?: string
  isAfter: boolean
  isBefore: boolean
  isCurrent: boolean
  text: string
  percentage?: number
  onPress: () => void
  testID?: string
}

const DayItem: React.FC<DayItemProps> = ({
  day,
  selectedDay,
  isAfter,
  isBefore,
  isCurrent,
  text,
  percentage,
  onPress,
  testID = 'dayItem',
}) => {
  return (
    <DialogueTouchableOpacity
      onPress={onPress}
      disabled={isAfter}
      testID={testID}
      accessibilityLabel={moment(day).format('LL')}
    >
      <DayProgress
        $isAfter={isAfter}
        $isBefore={isBefore}
        $isCurrent={isCurrent}
        percentage={isAfter ? 0 : percentage}
        radius={DAY_ITEM_SIZE / 2}
        strokeWidth={DAY_ITEM_BORDER_WIDTH}
        text={text}
      />
      {selectedDay === day && <SelectedDayIndicator testID={`${testID}Dot`} />}
      <FullSizeTouchTarget />
    </DialogueTouchableOpacity>
  )
}

export default DayItem
